import { IconSource } from '@hglobal/common';
import { ALL_ICONS } from '@fb/icons/generated/icons';
import { FloatingButtonConfig } from '@fb/models';

/** Base sprite + portal `config.icons` overrides (stable for SvgIconRegistryService). */
export function buildFloatingButtonIconSet(
  config: FloatingButtonConfig | undefined,
): IconSource[] {
  let allIcons = [...ALL_ICONS];
  const icons = config?.icons ?? {};

  for (const iconKey of Object.keys(icons)) {
    const source = icons[iconKey];
    allIcons = allIcons.filter(icon => icon.id !== iconKey);
    allIcons.push({
      id: iconKey,
      symbol: source.symbol.replace(/id="[^"]*"/g, `id="${iconKey}"`),
    });
  }

  return allIcons;
}
